import type { UpdateInvoiceAdditionalDetailsRequestPayload, UpdateInvoiceAdditionalDetailsResponse } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useUpdateInvoiceAdditionalDetails(
  options?: UseMutationOptions<UpdateInvoiceAdditionalDetailsResponse, unknown, UpdateInvoiceAdditionalDetailsRequestPayload>) {
  return useMutation((updateInvoiceAdditionalDetailsRequest) => {
    const api = getPrivateApi();

    return api.updateInvoiceAdditionalDetails({ updateInvoiceAdditionalDetailsRequest });
  }, options);
}